import React, { useState } from 'react';

//search context
export const NotificationContext = React.createContext();

const useNotificationContext = () => {
    const context = React.useContext(NotificationContext);
    if(!context) {
        throw new Error('useNotificationContext must be used within a NotificationContextProvider');
    }
    return context;
}

const NotificationContextProvider = props => {
    const [notification, setNotification] = useState({ open: false, message: '', actions: [] });

    const setNotificationHandler = ({ message, actions=[] }) => {
        setNotification({ open: true, message, actions });
    };

    const value = React.useMemo(() => [notification, setNotificationHandler], [notification]);

    return (
        <NotificationContext.Provider value={value} {...props} />
    );
}

export default { NotificationContextProvider, useNotificationContext };